import { apiRequest } from '../../../api/client';
import type { AdminAuthResponse, AdminAuthTokenResponse } from '../../../api/types';

// PARA-106, AC-1: логин/пароль администратора.
// PARA-151 (AC-3/AC-4): ответ — дискриминированное объединение: финальный
// admin_access_token (MFA выключена) или { mfa_required, mfa_token } (шаг TOTP).
export async function authenticateAdmin(
  login: string,
  password: string,
): Promise<AdminAuthResponse> {
  return apiRequest<AdminAuthResponse>('/admin/auth', {
    method: 'POST',
    body: { login, password },
    skipAuth: true,
  });
}

// PARA-151, AC-5/AC-E3/AC-E4: шаг 2 логина — проверка TOTP-кода по
// промежуточному mfa_token. Публичный эндпоинт (skipAuth, как и логин):
// авторизацией служит сам mfa_token. 401 — generic (неверный код ИЛИ
// недействительный/просроченный mfa_token), 429 — rate-limit.
export async function verifyMfaLogin(
  mfaToken: string,
  totpCode: string,
): Promise<AdminAuthTokenResponse> {
  return apiRequest<AdminAuthTokenResponse>('/admin/auth/mfa/verify', {
    method: 'POST',
    body: { mfa_token: mfaToken, totp_code: totpCode },
    skipAuth: true,
  });
}
